import { xhrPath } from '@/xhr/connections.js';
import picador from '@/xhr/connections/picador';

export default {
  /**
   * Status
   */
  async basisUpload(basisData) {
    return await picador.post('basisUpload', xhrPath.basisUpload, basisData);
  },
  async getDocumentStatus(documentID) {
    return await picador.get('getDocumentStatus', xhrPath.debates({ documentID }) + '/status');
  },

  async updateDocumentStatus(documentID, status, sourceType) {
    return await picador.put('updateDocumentStatus', `${xhrPath.document({ documentID })}/status`, {
      status,
      sourceType,
    });
  },

  /**
   * Details
   */

  async getDocumentDetails(documentID, publicLinkId) {
    return await picador.get('getDocumentDetails', `${xhrPath.documents({ documentID })}/details`, {
      params: { publicLinkId },
    });
  },

  async createDocument(documentData) {
    return await picador.post('createDocument', xhrPath.document({}), documentData);
  },

  async updateDocument(documentID, documentData) {
    return await picador.put('updateDocument', xhrPath.document({ documentID }), documentData);
  },

  async cloneDocument(documentID, documentData) {
    return await picador.post(
      'cloneDocument',
      `/api/v1/document/${documentID}/clone`,
      documentData
    );
  },

  async getNodeFromText(text) {
    return await picador.post('getNodeFromText', `/api/v1/document/getnodesbytext`, text);
  },

  async updateSourceDocument(sourceDocumentID, documentSourceData) {
    return await picador.put(
      'updateSourceDocument',
      `${xhrPath.sourceDocument({ sourceDocumentID })}`,
      documentSourceData
    );
  },

  async finalizeDraftedDocument(documentID, documentData) {
    return await picador.post(
      'finalizeDraftedDocument',
      `${xhrPath.document({ documentID })}/finalize`,
      documentData
    );
  },

  async getExtractedArticle(link) {
    return await picador.post(
      'getExtractedArticle',
      `${xhrPath.sourceDocument({})}/extract_async`,
      link
    );
  },
  async getExtractedArticleStatus(sourceDocumentID) {
    return await picador.get(
      'getExtractedArticleStatus',
      `${xhrPath.sourceDocument({})}/extract_async_status/${sourceDocumentID}`
    );
  },
  async runAnalyticOutlineAsync(sourceDocumentID, generateRunAnalytic) {
    return await picador.post(
      'runAnalyticOutlineAsync',
      `${xhrPath.sourceDocument({ sourceDocumentID })}/run_analytic_async`,
      generateRunAnalytic
    );
  },
  async runAnalyticAsyncStatus(sourceDocumentID) {
    return await picador.get(
      'runAnalyticAsyncStatus',
      `${xhrPath.sourceDocument({ sourceDocumentID })}/run_analytic_async_status`
    );
  },
  async listAnalyticAsync(sourceDocumentID) {
    return await picador.get(
      'listAnalyticAsync',
      `${xhrPath.sourceDocument({ sourceDocumentID })}/list_language_analytics`
    );
  },
  async runLanguageAnalyticAsync(sourceDocumentID, generateRunAnalytic) {
    return await picador.post(
      'runLanguageAnalyticOutlineAsync',
      `${xhrPath.sourceDocument({ sourceDocumentID })}/run_language_analytic_async`,
      generateRunAnalytic
    );
  },
  async runLanguageAnalyticAsyncStatus(sourceDocumentID) {
    return await picador.get(
      'runLanguageAnalyticAsyncStatus',
      `${xhrPath.sourceDocument({ sourceDocumentID })}/run_language_analytic_async_status`
    );
  },

  async getSourceDocumentDetails(sourceDocumentID) {
    return await picador.get(
      'getSourceDocumentDetails',
      `${xhrPath.sourceDocument({ sourceDocumentID })}/details`
    );
  },

  async getParticularDocument(sourceDocumentID) {
    return await picador.get(
      'getParticularDocument',
      `${xhrPath.sourceDocument({ sourceDocumentID })}`
    );
  },

  // New v2 source document endpoints
  async getSourceDocumentsByDocument(documentId) {
    return await picador.get('getSourceDocumentsByDocument', `${xhrPath.sourceDocument({})}`, {
      params: { document_id: documentId },
    });
  },

  async getSourceDocumentsByDebate(debateId) {
    return await picador.get('getSourceDocumentsByDebate', `${xhrPath.sourceDocument({})}`, {
      params: { debate_id: debateId },
    });
  },

  async getSourceDocumentById(sourceDocumentId) {
    return await picador.get(
      'getSourceDocumentById',
      `${xhrPath.sourceDocument({ sourceDocumentID: sourceDocumentId })}`
    );
  },

  async deleteSourceDocument(sourceDocumentID) {
    return await picador.delete(
      'deleteSourceDocument',
      `${xhrPath.sourceDocument({ sourceDocumentID })}`
    );
  },

  async addNewSourceDocument(documentData) {
    return await picador.post('addNewSourceDocument', xhrPath.sourceDocument({}), documentData);
  },

  async outlineSourceDocument(sourceDocumentID, generateOutlineData) {
    return await picador.post(
      'outlineSourceDocument',
      `${xhrPath.sourceDocument({ sourceDocumentID })}/outline`,
      generateOutlineData
    );
  },
  async runAnalyticDocument(sourceDocumentID, generateRunAnalytic) {
    return await picador.post(
      'runAnalyticDocument',
      `${xhrPath.sourceDocument({ sourceDocumentID })}/run_analytic`,
      generateRunAnalytic
    );
  },
  async listAnalyticDocument() {
    return await picador.get('listAnalyticDocument', `/api/v2/source_document/list_analytics`);
  },
  async runAnalyticAsync(sourceDocumentID, generateOutlineData) {
    return await picador.post(
      'runAnalyticAsync',
      `${xhrPath.sourceDocument({ sourceDocumentID })}/run_analytic_async`,
      generateOutlineData
    );
  },
};
